import { CssBaseline } from '@mui/material';
import { ThemeProvider } from '@mui/system';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { AudioSchedulerProvider } from './audio/audioSchedulerContext';
import { MutedProvider } from './audio/mutedContext';
import { ConfigProvider } from './config/configContext';
import { NowProvider } from './hooks/nowContext';
import theme from './muiTheme';
import "./styles/app.css";


const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
    <React.StrictMode>
        <CssBaseline />
        <ThemeProvider theme={theme}>
            <ConfigProvider>
                <AudioSchedulerProvider>
                    <NowProvider>
                        <BrowserRouter>
                            <MutedProvider>
                                <App />
                            </MutedProvider>
                        </BrowserRouter>
                    </NowProvider>
                </AudioSchedulerProvider>
            </ConfigProvider>
        </ThemeProvider>
    </React.StrictMode >
);
